import React, { PureComponent } from "react";
import Button from "antd/lib/button";
import Popconfirm from "antd/lib/popconfirm";
import List from "antd/lib/list";
import Input from "antd/lib/input";

import find from "lodash/find";
import get from "lodash/get";
import { getAllData } from "helpers/api";
import WordSearch from "./WordSearch";

import { readLists, updateLists } from "helpers/api";

import "./style.css";

class Lists extends PureComponent {
  state = {
    words: [],
    lists: [],
    uneditedLists: [],
    newListID: "",
    newListName: "",
    isEdited: false
  };

  componentDidMount = () => {
    this.readLists();
    const words = localStorage.getItem("allData");
    if (!words) {
      this.fetchAllLevels();
    } else {
      console.log("all levels exist in local storage");
      this.setState({ words: JSON.parse(words) });
    }
  };

  componentDidUpdate() {
    const { uneditedLists, lists } = this.state;
    if (uneditedLists.length === 0 || lists.length === 0) return;
    let isEdited = false;
    console.log("Changes:");
    lists.forEach((list, index) => {
      if (!uneditedLists[index]) {
        isEdited = true;
        console.log(`New list created with id: ${list.id}`);
      } else {
        if (
          uneditedLists[index] &&
          uneditedLists[index].wordIDs.length !== list.wordIDs.length
        ) {
          isEdited = true;
          console.log(`Contents of list id: ${list.id} changed`);
        } else {
          let changed = false;
          list.wordIDs.forEach((item, i) => {
            if (get(uneditedLists, [index, "wordIDs", i]) !== item) {
              isEdited = true;
              changed = true;
            }
          });
          changed && console.log(`Contents of list id: ${list.id} changed`);
        }
        if (uneditedLists[index] && uneditedLists[index].name !== list.name) {
          isEdited = true;
          console.log(`Name of list id: ${list.id} changed`);
        }
      }
    });
    !isEdited && console.log("no changes");
    console.log("====================");
    if (this.state.isEdited !== isEdited) {
      this.setState({ isEdited });
    }
  }

  handleSave = async () => {
    await updateLists(this.state.lists);
    this.readLists();
  };

  readLists = async () => {
    const { data } = await readLists();
    this.setState({ lists: data, uneditedLists: data });
  };

  addWordToList = (listID, wordID) => {
    this.setState(prevState => ({
      lists: prevState.lists.map(list => {
        if (list.id === listID) {
          return { ...list, wordIDs: [...new Set([...list.wordIDs, wordID])] };
        }
        return list;
      })
    }));
  };

  handleListAdd = () => {
    const { newListName, newListID, lists } = this.state;
    const isListIDExist = !!find(lists, { id: newListID });
    if (newListName.length > 0 && newListID.length > 0 && !isListIDExist) {
      this.setState(prevState => ({
        lists: [
          ...prevState.lists,
          {
            id: newListID,
            name: newListName,
            wordIDs: []
          }
        ],
        newListName: "",
        newListID: ""
      }));
    }
  };

  removeWordFromList = (listID, wordID) => {
    this.setState(prevState => ({
      lists: prevState.lists.map(list => {
        if (list.id === listID) {
          return { ...list, wordIDs: list.wordIDs.filter(id => id !== wordID) };
        }
        return list;
      })
    }));
  };

  handleListNameChange = (listID, newName) => {
    this.setState(prevState => ({
      lists: prevState.lists.map(list => {
        if (list.id === listID) {
          return { ...list, name: newName };
        }
        return list;
      })
    }));
  };

  fetchAllLevels = async () => {
    this.setState({ words: [] });
    console.log("fetching all levels");
    const data = [];
    const response = await getAllData();
    JSON.parse(response).forEach(level => {
      level.words.forEach(word => {
        const { image, ...rest } = word;
        data.push({ ...rest, key: word.id, levelID: level.id });
      });
    });
    localStorage.setItem("allData", JSON.stringify(data));
    this.setState({ words: data });
  };

  render() {
    const { lists, words, newListName, newListID, isEdited } = this.state;
    return (
      <div style={{ margin: 50 }}>
        {words.length > 0 &&
          lists.length > 0 &&
          lists.map(list => (
            <List
              key={list.name}
              header={
                <div>
                  <b>LIST ID: {list.id}</b>
                  <Input.Search
                    placeholder="LIST NAME"
                    style={{ width: 350, marginLeft: 20 }}
                    defaultValue={list.name}
                    enterButton="SAVE NEW NAME"
                    onSearch={value =>
                      this.handleListNameChange(list.id, value)
                    }
                  />
                </div>
              }
              footer={
                <WordSearch
                  listID={list.id}
                  words={words}
                  addWordToList={this.addWordToList}
                  wordIDs={list.wordIDs}
                />
              }
              bordered
              dataSource={list.wordIDs}
              style={{ marginBottom: 20 }}
              renderItem={id => {
                const word = find(words, { id });
                return (
                  <List.Item
                    actions={[
                      <a onClick={() => this.removeWordFromList(list.id, id)}>
                        delete
                      </a>
                    ]}
                  >{`ID: ${word.id} | DE: ${word.de} | EN: ${word.en} | TR: ${
                    word.tr
                  }`}</List.Item>
                );
              }}
            />
          ))}
        <div>
          <h2>ADD NEW LIST</h2>
          <Input
            placeholder="LIST ID"
            value={newListID}
            onChange={e => this.setState({ newListID: e.target.value })}
          />
          <Input
            placeholder="LIST NAME"
            value={newListName}
            onChange={e => this.setState({ newListName: e.target.value })}
            style={{ margin: "10px 0" }}
          />
          <Button type="primary" onClick={this.handleListAdd}>
            ADD LIST
          </Button>
        </div>
        {isEdited && (
          <div className="Lists__button-save">
            <Button type="danger" onClick={this.handleSave} size="large">
              SAVE CHANGES
            </Button>
          </div>
        )}
        <div style={{ marginTop: 100 }}>
          <Popconfirm
            title="DO THIS IF YOU EDITED ONE OF THE WORDS"
            okText="GET"
            cancelText="CANCEL"
            onConfirm={this.fetchAllLevels}
          >
            <Button>GET ALL LEVELS</Button>
          </Popconfirm>
          <Button
            type="primary"
            onClick={() => console.log(JSON.stringify(lists))}
            style={{ marginLeft: 20 }}
          >
            CONSOLE LOG LISTS
          </Button>
        </div>
      </div>
    );
  }
}

export default Lists;



// WEBPACK FOOTER //
// ./src/containers/Lists/index.js